export function showFormErrorMessage(errors: readonly string[]): string {
  return errors.join(', ');
}
